module.exports = __webpack_public_path__ + "img/kh31.9eee118e.png";